/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createSaturnTestData = /* GraphQL */ `
  mutation CreateSaturnTestData(
    $input: CreateSaturnTestDataInput!
    $condition: ModelSaturnTestDataConditionInput
  ) {
    createSaturnTestData(input: $input, condition: $condition) {
      id
      totalPoints
      totalTime
      executiveMiniTrailsB
      executiveStroop
      math
      meanPredictiveZScores
      memoryFiveWords
      memoryIncidental
      motorSpeed
      orientation
      readingSpeed
      simpleAttention
      visuospatialImageCombos
      visuospatialMiniTrailsA
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateSaturnTestData = /* GraphQL */ `
  mutation UpdateSaturnTestData(
    $input: UpdateSaturnTestDataInput!
    $condition: ModelSaturnTestDataConditionInput
  ) {
    updateSaturnTestData(input: $input, condition: $condition) {
      id
      totalPoints
      totalTime
      executiveMiniTrailsB
      executiveStroop
      math
      meanPredictiveZScores
      memoryFiveWords
      memoryIncidental
      motorSpeed
      orientation
      readingSpeed
      simpleAttention
      visuospatialImageCombos
      visuospatialMiniTrailsA
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteSaturnTestData = /* GraphQL */ `
  mutation DeleteSaturnTestData(
    $input: DeleteSaturnTestDataInput!
    $condition: ModelSaturnTestDataConditionInput
  ) {
    deleteSaturnTestData(input: $input, condition: $condition) {
      id
      totalPoints
      totalTime
      executiveMiniTrailsB
      executiveStroop
      math
      meanPredictiveZScores
      memoryFiveWords
      memoryIncidental
      motorSpeed
      orientation
      readingSpeed
      simpleAttention
      visuospatialImageCombos
      visuospatialMiniTrailsA
      createdAt
      updatedAt
      __typename
    }
  }
`;
